// import service from '@/api/modules/service_app';
// import { GlobalStore } from '@/store';
// import axios from 'axios';
import service from '@/api';
import dum_usermap from './dummy/usermap.json';
import dum_contents from './dummy/contents.json';
const timeout = () => new Promise((resolve) => setTimeout(resolve, 500));

/** * 전체 학습 이력 데이타 받아오기  */
export const getKnowledgeMap = async (token) => {
    // await timeout();
    // return dum_usermap;

    try {
        const res = await service({
            url: '/api/knowledgemap/info',
            method: 'get',
            // headers: { Authorization: `Bearer ${token}` },
        });
        // console.log('--getKnowledgeMap-DATA:', res);
        return res;
    } catch (e) {
        return e.response ? e.response : null;
    }
};

/**  * 작품별로 보기 검색   */
export const searchContents = async (token, arrLev, arrTopic) => {
    // await timeout();
    // return dum_contents;

    const param = {
        levelParamList: arrLev.join(),
        classList: arrTopic.join(),
    };
    // console.log('--searchContents--param-', param);
    try {
        const res = await service({
            url: '/api/knowledgemap/passage-info',
            method: 'get',
            params: param,
            // headers: { Authorization: `Bearer ${token}` },
        });
        // console.log('--searchContents-DATA:', res);
        return res;
    } catch (e) {
        return e.response ? e.response : null;
    }
};
